import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const NAMES = ['Ana', 'Sofía', 'Camila', 'Isabella', 'Daniela', 'Fernanda', 'Gabriela', 'Mariana', 'Paula', 'Alejandra', 'Rosa', 'Carmen', 'Elena', 'Diana', 'Natalia', 'Jimena', 'Renata', 'Catalina', 'Adriana', 'Mónica'];
const CITIES = ['Ciudad de México', 'Bogotá', 'Lima', 'Buenos Aires', 'Medellín', 'Guadalajara', 'Santiago', 'Quito', 'Monterrey', 'Caracas', 'San José', 'Panamá', 'Santo Domingo', 'Tegucigalpa', 'La Paz', 'Cali', 'Puebla', 'Barranquilla', 'Córdoba', 'Rosario'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Auto-hide after 4 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 5000);
    // Setup recurring interval
    const interval = setInterval(() => {
      // Random interval between 8-12 seconds
      const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(showPopup, nextDelay);
    }, 15000); // Base interval, actual appearance is staggered
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-216">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border-l-4 border-purple-600 p-3 pr-6 flex items-center gap-3 max-w-[300px]" data-id="element-217">
          <img src="https://cdn.magicpatterns.com/uploads/dCvWEwRkVVWQkswmbpqaGx/COVER_N1.png" alt="Quincena Sin Ansiedad" className="w-10 h-14 object-cover rounded shadow-sm" data-id="element-218" />
          <div data-id="element-219">
            <p className="text-sm text-gray-800 font-medium" data-id="element-220">
              <span className="font-bold text-purple-700" data-id="element-221">{currentName}</span>{' '}
              de {currentCity}
            </p>
            <p className="text-xs text-gray-500" data-id="element-222">
              acaba de comprar Quincena Sin Ansiedad
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}